import { useState, useEffect } from 'react';
export default (breakpoint = 1024) => {
  const [enhanced, setEnhanced] = useState(window.innerWidth >= breakpoint);

  useEffect(() => {
    const onResize = () => {
      setEnhanced(window.innerWidth >= breakpoint);
    };
    window.addEventListener('resize', onResize);

    return function cleanup() {
      window.removeEventListener('resize', onResize);
    };
  }, [breakpoint]);

  return enhanced;
};
